<input
  type="range"
  class="form-range"
  [min]="min()"
  [max]="max()"
  [step]="step()"
  [value]="value()"
  (input)="onInput($any($event.target).value)"
/>
